export default __webpack_public_path__ + "static/media/beer-jar.cd0c3d02.png";